/**
  * * Generated by @amzn/ring-common-style-library/scripts/build-colors.ts
  * * on 2025-03-06T13:42:16.251Z.
  * */
const NEUTRAL_50 = '#FAFBFC';
const NEUTRAL_900 = '#121212';
const NEUTRAL_800 = '#282B2F';
const NEUTRAL_500 = '#424242';
const NEUTRAL_300 = '#6E6E6E';
const NEUTRAL_200 = '#BDBDBD';
const NEUTRAL_100 = '#ECECEC';
const PRIMARY_800 = '#003d61';
const PRIMARY_700 = '#005188';
const PRIMARY_600 = '#0063A5';
const PRIMARY_500 = '#0074C2';
const PRIMARY_400 = '#37B6F3';
const PRIMARY_300 = '#65BAEB';
const PRIMARY_200 = '#A4DEFF';
const PRIMARY_100 = '#EFF8FC';
const SECONDARY_800 = '#602500';
const SECONDARY_700 = '#9C4308';
const SECONDARY_600 = '#C74E00';
const SECONDARY_500 = '#F1670D';
const SECONDARY_400 = '#FF852B';
const SECONDARY_300 = '#F69C61';
const SECONDARY_200 = '#FACAAB';
const SECONDARY_100 = '#FDEFE6';
const POSITIVE_800 = '#0B4A0C';
const POSITIVE_700 = '#22580E';
const POSITIVE_600 = '#157217';
const POSITIVE_500 = '#178019';
const POSITIVE_400 = '#5EBF60';
const POSITIVE_300 = '#83C284';
const POSITIVE_200 = '#BCDEBD';
const POSITIVE_100 = '#F0F8F0';
const NEGATIVE_800 = '#780500';
const NEGATIVE_700 = '#96231D';
const NEGATIVE_600 = '#B8251D';
const NEGATIVE_500 = '#D4231A';
const NEGATIVE_400 = '#FF554B';
const NEGATIVE_300 = '#EF7D76';
const NEGATIVE_200 = '#F7B9B6';
const NEGATIVE_100 = '#FCEFEF';
const CAUTION_800 = '#866E04';
const CAUTION_700 = '#A48C22';
const CAUTION_600 = '#CBAC20';
const CAUTION_500 = '#FDD835';
const CAUTION_400 = '#FFF653';
const CAUTION_300 = '#FDE57B';
const CAUTION_200 = '#FFF2B9';
const CAUTION_100 = '#FEFBEA';
const AMAZON_700 = '#A66300';
const AMAZON_500 = '#FF9900';
const AMAZON_200 = '#FFDBA6';
const TERTIARY_900 = '#363E47';
const TERTIARY_800 = '#4E5761';
const TERTIARY_700 = '#81919F';
const TERTIARY_500 = '#DEE5EC';
const TERTIARY_300 = '#F6F8FA';
const WHITE_150 = '#FFFFFF26';
const WHITE_200 = '#FFFFFF59';
const WHITE_900 = '#FFFFFF';
const BLACK_900 = '#000000';
const BLACK_300 = '#000000A6';
const BLACK_700 = '#000000CC';
const TRANSPARENT = '#FFFFFF00';
const DOORBELL_500 = '#0080CC';
const CAMERA_500 = '#119E96';
const ALARM_500 = '#D23313';
const LIGHTING_500 = '#7248B5';
const TAGS_500 = '#F52C4F';
const ACCESSORY_500 = '#A97A3F';
const ACCESS_CONTROLLER_500 = '#00994A';
const WORKS_WITH_RING_500 = '#737578';
/* -----TODO: Legacy Colors to be replaced by the color variable when get confirms by designer ----- */
const NATIVE_GREY = '#808080';
const SNOW = '#fafafa';
const GREY_78 = '#c7c7c7';
const FORD_GREY = '#979797';
const GREY_53 = '#878787';
const NEXT_DOOR_GREEN = '#40A142';
const FACEBOOK_BLUE = '#006494';
const TWITTER_PRIMARY = '#4DC2FA';
/*---------------------------------------------------------*/
/* ----- Import CSS to reference semantic values correctly ----- */
const BACKGROUND_DEEP = 'var(--background-deep)';
const SURFACE_BASE = 'var(--surface-base)';
const SURFACE_INVERTED = 'var(--surface-inverted)';
const CONTENT_BASE = 'var(--content-base)';
const CONTENT_BACKUP = 'var(--content-backup)';
const CONTENT_DISABLED = 'var(--content-disabled)';
const CONTENT_MUTED = 'var(--content-muted)';
const BUTTON_CONTENT_BASE = 'var(--button-content-base)';
const CONTENT_INVERTED = 'var(--content-inverted)';
const PRIMARY_PRESS = 'var(--primary-press)';
const PRIMARY_HOVER = 'var(--primary-hover)';
const PRIMARY_BASE = 'var(--primary-base)';
const PRIMARY_DISABLED = 'var(--primary-disabled)';
const PRIMARY_MUTED = 'var(--primary-muted)';
const PRIMARY_TEXT_LINK_PRESS = 'var(--primary-text-link-press)';
const PRIMARY_TEXT_LINK_HOVER = 'var(--primary-text-link-hover)';
const PRIMARY_TEXT_LINK_BASE = 'var(--primary-text-link-base)';
const SECONDARY_PRESS = 'var(--secondary-press)';
const SECONDARY_HOVER = 'var(--secondary-hover)';
const SECONDARY_BASE = 'var(--secondary-base)';
const SECONDARY_DISABLED = 'var(--secondary-disabled)';
const SECONDARY_MUTED = 'var(--secondary-muted)';
const POSITIVE_PRESS = 'var(--positive-press)';
const POSITIVE_HOVER = 'var(--positive-hover)';
const POSITIVE_BASE = 'var(--positive-base)';
const POSITIVE_DISABLED = 'var(--positive-disabled)';
const POSITIVE_MUTED = 'var(--positive-muted)';
const NEGATIVE_PRESS = 'var(--negative-press)';
const NEGATIVE_HOVER = 'var(--negative-hover)';
const NEGATIVE_BASE = 'var(--negative-base)';
const NEGATIVE_DISABLED = 'var(--negative-disabled)';
const NEGATIVE_MUTED = 'var(--negative-muted)';
const CAUTION_PRESS = 'var(--caution-press)';
const CAUTION_HOVER = 'var(--caution-hover)';
const CAUTION_BASE = 'var(--caution-base)';
const CAUTION_DISABLED = 'var(--caution-disabled)';
const CAUTION_MUTED = 'var(--caution-muted)';
const AMAZON_PRESS = 'var(--amazon-press)';
const AMAZON_BASE = 'var(--amazon-base)';
const AMAZON_DISABLED = 'var(--amazon-disabled)';
const TERTIARY_BORDER_DEEP = 'var(--tertiary-border-deep)';
const TERTIARY_BORDER = 'var(--tertiary-border)';
const TERTIARY_BACKGROUND = 'var(--tertiary-background)';
const DEPTH_BORDER_MUTED = 'var(--depth-border-muted)';
const DEPTH_BORDER_BASE = 'var(--depth-border-base)';
const CONSTANT_SCRIM_BASE = 'var(--constant-scrim-base)';
const CONSTANT_SCRIM_STRONG = 'var(--constant-scrim-strong)';
const CONSTANT_BACKGROUND_BASE = 'var(--constant-background-base)';
const CONSTANT_BACKGROUND_DEEP = 'var(--constant-background-deep)';
const CONSTANT_SURFACE_BASE = 'var(--constant-surface-base)';
const CONSTANT_CONTENT_BASE = 'var(--constant-content-base)';
const CONSTANT_CONTENT_BACKUP = 'var(--constant-content-backup)';
const CONSTANT_CONTENT_DISABLED = 'var(--constant-content-disabled)';
const CONSTANT_PRIMARY_PRESS = 'var(--constant-primary-press)';
const CONSTANT_PRIMARY_HOVER = 'var(--constant-primary-hover)';
const CONSTANT_PRIMARY_BASE = 'var(--constant-primary-base)';
const CONSTANT_PRIMARY_DISABLED = 'var(--constant-primary-disabled)';
const CONSTANT_PRIMARY_MUTED = 'var(--constant-primary-muted)';
const CONSTANT_PRIMARY_TEXT_LINK_BASE = 'var(--constant-primary-text-link-base)';
const CONSTANT_PRIMARY_TEXT_LINK_HOVER = 'var(--constant-primary-text-link-hover)';
const CONSTANT_PRIMARY_TEXT_LINK_PRESS = 'var(--constant-primary-text-link-press)';
const CONSTANT_NEGATIVE_PRESS = 'var(--constant-negative-press)';
const CONSTANT_NEGATIVE_HOVER = 'var(--constant-negative-hover)';
const CONSTANT_NEGATIVE_BASE = 'var(--constant-negative-base)';
const CONSTANT_NEGATIVE_DISABLED = 'var(--constant-negative-disabled)';
const CONSTANT_NEGATIVE_MUTED = 'var(--constant-negative-muted)';
const CONSTANT_TERTIARY_BACKGROUND = 'var(--constant-tertiary-background)';
const CONSTANT_TERTIARY_BORDER = 'var(--constant-tertiary-border)';
const CONSTANT_DOORBELL_BASE = 'var(--constant-doorbell-base)';
const CONSTANT_CAMERA_BASE = 'var(--constant-camera-base)';
const CONSTANT_ALARM_BASE = 'var(--constant-alarm-base)';
const CONSTANT_LIGHTING_BASE = 'var(--constant-lighting-base)';
const CONSTANT_TAGS_BASE = 'var(--constant-tags-base)';
const CONSTANT_ACCESSORY_BASE = 'var(--constant-accessory-base)';
const CONSTANT_ACCESS_CONTROLLER_BASE = 'var(--constant-access-controller-base)';
const CONSTANT_WORKS_WITH_RING_BASE = 'var(--constant-works-with-ring-base)';
const COLORS = {
    NEUTRAL_50,
    NEUTRAL_900,
    NEUTRAL_800,
    NEUTRAL_500,
    NEUTRAL_300,
    NEUTRAL_200,
    NEUTRAL_100,
    PRIMARY_800,
    PRIMARY_700,
    PRIMARY_600,
    PRIMARY_500,
    PRIMARY_400,
    PRIMARY_300,
    PRIMARY_200,
    PRIMARY_100,
    SECONDARY_800,
    SECONDARY_700,
    SECONDARY_600,
    SECONDARY_500,
    SECONDARY_400,
    SECONDARY_300,
    SECONDARY_200,
    SECONDARY_100,
    POSITIVE_800,
    POSITIVE_700,
    POSITIVE_600,
    POSITIVE_500,
    POSITIVE_400,
    POSITIVE_300,
    POSITIVE_200,
    POSITIVE_100,
    NEGATIVE_800,
    NEGATIVE_700,
    NEGATIVE_600,
    NEGATIVE_500,
    NEGATIVE_400,
    NEGATIVE_300,
    NEGATIVE_200,
    NEGATIVE_100,
    CAUTION_800,
    CAUTION_700,
    CAUTION_600,
    CAUTION_500,
    CAUTION_400,
    CAUTION_300,
    CAUTION_200,
    CAUTION_100,
    AMAZON_700,
    AMAZON_500,
    AMAZON_200,
    TERTIARY_900,
    TERTIARY_800,
    TERTIARY_700,
    TERTIARY_500,
    TERTIARY_300,
    WHITE_150,
    WHITE_200,
    WHITE_900,
    BLACK_900,
    BLACK_300,
    BLACK_700,
    TRANSPARENT,
    DOORBELL_500,
    CAMERA_500,
    ALARM_500,
    LIGHTING_500,
    TAGS_500,
    ACCESSORY_500,
    ACCESS_CONTROLLER_500,
    WORKS_WITH_RING_500,
    /* -----TODO: Legacy Colors to be replaced by the color variable when get confirms by designer ----- */
    NATIVE_GREY,
    SNOW,
    GREY_78,
    FORD_GREY,
    GREY_53,
    NEXT_DOOR_GREEN,
    FACEBOOK_BLUE,
    TWITTER_PRIMARY,
    /*---------------------------------------------------------*/
};
const SEMANTIC_COLORS = {
    BACKGROUND_DEEP,
    SURFACE_BASE,
    SURFACE_INVERTED,
    CONTENT_BASE,
    CONTENT_BACKUP,
    CONTENT_DISABLED,
    CONTENT_MUTED,
    BUTTON_CONTENT_BASE,
    CONTENT_INVERTED,
    PRIMARY_PRESS,
    PRIMARY_HOVER,
    PRIMARY_BASE,
    PRIMARY_DISABLED,
    PRIMARY_MUTED,
    PRIMARY_TEXT_LINK_PRESS,
    PRIMARY_TEXT_LINK_HOVER,
    PRIMARY_TEXT_LINK_BASE,
    SECONDARY_PRESS,
    SECONDARY_HOVER,
    SECONDARY_BASE,
    SECONDARY_DISABLED,
    SECONDARY_MUTED,
    POSITIVE_PRESS,
    POSITIVE_HOVER,
    POSITIVE_BASE,
    POSITIVE_DISABLED,
    POSITIVE_MUTED,
    NEGATIVE_PRESS,
    NEGATIVE_HOVER,
    NEGATIVE_BASE,
    NEGATIVE_DISABLED,
    NEGATIVE_MUTED,
    CAUTION_PRESS,
    CAUTION_HOVER,
    CAUTION_BASE,
    CAUTION_DISABLED,
    CAUTION_MUTED,
    AMAZON_PRESS,
    AMAZON_BASE,
    AMAZON_DISABLED,
    TERTIARY_BORDER_DEEP,
    TERTIARY_BORDER,
    TERTIARY_BACKGROUND,
    DEPTH_BORDER_MUTED,
    DEPTH_BORDER_BASE,
    CONSTANT_SCRIM_BASE,
    CONSTANT_SCRIM_STRONG,
    CONSTANT_BACKGROUND_BASE,
    CONSTANT_BACKGROUND_DEEP,
    CONSTANT_SURFACE_BASE,
    CONSTANT_CONTENT_BASE,
    CONSTANT_CONTENT_BACKUP,
    CONSTANT_CONTENT_DISABLED,
    CONSTANT_PRIMARY_PRESS,
    CONSTANT_PRIMARY_HOVER,
    CONSTANT_PRIMARY_BASE,
    CONSTANT_PRIMARY_DISABLED,
    CONSTANT_PRIMARY_MUTED,
    CONSTANT_PRIMARY_TEXT_LINK_BASE,
    CONSTANT_PRIMARY_TEXT_LINK_HOVER,
    CONSTANT_PRIMARY_TEXT_LINK_PRESS,
    CONSTANT_NEGATIVE_PRESS,
    CONSTANT_NEGATIVE_HOVER,
    CONSTANT_NEGATIVE_BASE,
    CONSTANT_NEGATIVE_DISABLED,
    CONSTANT_NEGATIVE_MUTED,
    CONSTANT_TERTIARY_BACKGROUND,
    CONSTANT_TERTIARY_BORDER,
    CONSTANT_DOORBELL_BASE,
    CONSTANT_CAMERA_BASE,
    CONSTANT_ALARM_BASE,
    CONSTANT_LIGHTING_BASE,
    CONSTANT_TAGS_BASE,
    CONSTANT_ACCESSORY_BASE,
    CONSTANT_ACCESS_CONTROLLER_BASE,
    CONSTANT_WORKS_WITH_RING_BASE,
};
const SEMANTIC_COLOR_CODES = {
    backgroundDeep: {
        light: 'NEUTRAL_50',
        dark: 'NEUTRAL_900'
    },
    surfaceBase: {
        light: 'WHITE_900',
        dark: 'NEUTRAL_800'
    },
    surfaceInverted: {
        light: 'NEUTRAL_500',
        dark: 'WHITE_900'
    },
    contentBase: {
        light: 'NEUTRAL_500',
        dark: 'WHITE_900'
    },
    contentBackup: {
        light: 'NEUTRAL_300',
        dark: 'NEUTRAL_200'
    },
    contentDisabled: {
        light: 'NEUTRAL_200',
        dark: 'NEUTRAL_300'
    },
    contentMuted: {
        light: 'NEUTRAL_100',
        dark: 'NEUTRAL_500'
    },
    buttonContentBase: {
        light: 'WHITE_900',
        dark: 'NEUTRAL_800'
    },
    contentInverted: {
        light: 'WHITE_900',
        dark: 'NEUTRAL_500'
    },
    primaryPress: {
        light: 'PRIMARY_700',
        dark: 'PRIMARY_200'
    },
    primaryHover: {
        light: 'PRIMARY_600',
        dark: 'PRIMARY_300'
    },
    primaryBase: {
        light: 'PRIMARY_500',
        dark: 'PRIMARY_400'
    },
    primaryDisabled: {
        light: 'PRIMARY_200',
        dark: 'PRIMARY_700'
    },
    primaryMuted: {
        light: 'PRIMARY_100',
        dark: 'PRIMARY_800'
    },
    primaryTextLinkPress: {
        light: 'PRIMARY_700',
        dark: 'PRIMARY_200'
    },
    primaryTextLinkHover: {
        light: 'PRIMARY_600',
        dark: 'PRIMARY_300'
    },
    primaryTextLinkBase: {
        light: 'PRIMARY_500',
        dark: 'PRIMARY_400'
    },
    secondaryPress: {
        light: 'SECONDARY_700',
        dark: 'SECONDARY_200'
    },
    secondaryHover: {
        light: 'SECONDARY_600',
        dark: 'SECONDARY_300'
    },
    secondaryBase: {
        light: 'SECONDARY_500',
        dark: 'SECONDARY_400'
    },
    secondaryDisabled: {
        light: 'SECONDARY_200',
        dark: 'SECONDARY_700'
    },
    secondaryMuted: {
        light: 'SECONDARY_100',
        dark: 'SECONDARY_800'
    },
    positivePress: {
        light: 'POSITIVE_700',
        dark: 'POSITIVE_200'
    },
    positiveHover: {
        light: 'POSITIVE_600',
        dark: 'POSITIVE_300'
    },
    positiveBase: {
        light: 'POSITIVE_500',
        dark: 'POSITIVE_400'
    },
    positiveDisabled: {
        light: 'POSITIVE_200',
        dark: 'POSITIVE_700'
    },
    positiveMuted: {
        light: 'POSITIVE_100',
        dark: 'POSITIVE_800'
    },
    negativePress: {
        light: 'NEGATIVE_700',
        dark: 'NEGATIVE_200'
    },
    negativeHover: {
        light: 'NEGATIVE_600',
        dark: 'NEGATIVE_300'
    },
    negativeBase: {
        light: 'NEGATIVE_500',
        dark: 'NEGATIVE_400'
    },
    negativeDisabled: {
        light: 'NEGATIVE_200',
        dark: 'NEGATIVE_700'
    },
    negativeMuted: {
        light: 'NEGATIVE_100',
        dark: 'NEGATIVE_800'
    },
    cautionPress: {
        light: 'CAUTION_700',
        dark: 'CAUTION_200'
    },
    cautionHover: {
        light: 'CAUTION_600',
        dark: 'CAUTION_300'
    },
    cautionBase: {
        light: 'CAUTION_500',
        dark: 'CAUTION_400'
    },
    cautionDisabled: {
        light: 'CAUTION_200',
        dark: 'CAUTION_700'
    },
    cautionMuted: {
        light: 'CAUTION_100',
        dark: 'CAUTION_800'
    },
    amazonPress: {
        light: 'AMAZON_700',
        dark: 'AMAZON_200'
    },
    amazonBase: {
        light: 'AMAZON_500',
        dark: 'AMAZON_500'
    },
    amazonDisabled: {
        light: 'AMAZON_200',
        dark: 'AMAZON_700'
    },
    tertiaryBorderDeep: {
        light: 'TERTIARY_700',
        dark: 'TERTIARY_500'
    },
    tertiaryBorder: {
        light: 'TERTIARY_500',
        dark: 'TERTIARY_800'
    },
    tertiaryBackground: {
        light: 'TERTIARY_300',
        dark: 'TERTIARY_900'
    },
    depthBorderMuted: {
        light: 'TRANSPARENT',
        dark: 'WHITE_150'
    },
    depthBorderBase: {
        light: 'TRANSPARENT',
        dark: 'WHITE_200'
    },
    constantScrimBase: {
        light: 'BLACK_300'
    },
    constantScrimStrong: {
        light: 'BLACK_700'
    },
    constantBackgroundBase: {
        light: 'NEUTRAL_500'
    },
    constantBackgroundDeep: {
        light: 'NEUTRAL_900'
    },
    constantSurfaceBase: {
        light: 'NEUTRAL_800'
    },
    constantContentBase: {
        light: 'WHITE_900'
    },
    constantContentBackup: {
        light: 'NEUTRAL_200'
    },
    constantContentDisabled: {
        light: 'NEUTRAL_300'
    },
    constantPrimaryPress: {
        light: 'PRIMARY_200'
    },
    constantPrimaryHover: {
        light: 'PRIMARY_300'
    },
    constantPrimaryBase: {
        light: 'PRIMARY_400'
    },
    constantPrimaryDisabled: {
        light: 'PRIMARY_700'
    },
    constantPrimaryMuted: {
        light: 'PRIMARY_800'
    },
    constantPrimaryTextLinkBase: {
        light: 'PRIMARY_400'
    },
    constantPrimaryTextLinkHover: {
        light: 'PRIMARY_300'
    },
    constantPrimaryTextLinkPress: {
        light: 'PRIMARY_200'
    },
    constantNegativePress: {
        light: 'NEGATIVE_200'
    },
    constantNegativeHover: {
        light: 'NEGATIVE_300'
    },
    constantNegativeBase: {
        light: 'NEGATIVE_400'
    },
    constantNegativeDisabled: {
        light: 'NEGATIVE_700'
    },
    constantNegativeMuted: {
        light: 'NEGATIVE_800'
    },
    constantTertiaryBackground: {
        light: 'TERTIARY_900'
    },
    constantTertiaryBorder: {
        light: 'TERTIARY_800'
    },
    constantDoorbellBase: {
        light: 'DOORBELL_500'
    },
    constantCameraBase: {
        light: 'CAMERA_500'
    },
    constantAlarmBase: {
        light: 'ALARM_500'
    },
    constantLightingBase: {
        light: 'LIGHTING_500'
    },
    constantTagsBase: {
        light: 'TAGS_500'
    },
    constantAccessoryBase: {
        light: 'ACCESSORY_500'
    },
    constantAccessControllerBase: {
        light: 'ACCESS_CONTROLLER_500'
    },
    constantWorksWithRingBase: {
        light: 'WORKS_WITH_RING_500'
    }
};
const COLORS_CSS = `:root {
  --neutral-50: #FAFBFC;
  --neutral-900: #121212;
  --neutral-800: #282B2F;
  --neutral-500: #424242;
  --neutral-300: #6E6E6E;
  --neutral-200: #BDBDBD;
  --neutral-100: #ECECEC;
  --primary-800: #003d61;
  --primary-700: #005188;
  --primary-600: #0063A5;
  --primary-500: #0074C2;
  --primary-400: #37B6F3;
  --primary-300: #65BAEB;
  --primary-200: #A4DEFF;
  --primary-100: #EFF8FC;
  --secondary-800: #602500;
  --secondary-700: #9C4308;
  --secondary-600: #C74E00;
  --secondary-500: #F1670D;
  --secondary-400: #FF852B;
  --secondary-300: #F69C61;
  --secondary-200: #FACAAB;
  --secondary-100: #FDEFE6;
  --positive-800: #0B4A0C;
  --positive-700: #22580E;
  --positive-600: #157217;
  --positive-500: #178019;
  --positive-400: #5EBF60;
  --positive-300: #83C284;
  --positive-200: #BCDEBD;
  --positive-100: #F0F8F0;
  --negative-800: #780500;
  --negative-700: #96231D;
  --negative-600: #B8251D;
  --negative-500: #D4231A;
  --negative-400: #FF554B;
  --negative-300: #EF7D76;
  --negative-200: #F7B9B6;
  --negative-100: #FCEFEF;
  --caution-800: #866E04;
  --caution-700: #A48C22;
  --caution-600: #CBAC20;
  --caution-500: #FDD835;
  --caution-400: #FFF653;
  --caution-300: #FDE57B;
  --caution-200: #FFF2B9;
  --caution-100: #FEFBEA;
  --amazon-700: #A66300;
  --amazon-500: #FF9900;
  --amazon-200: #FFDBA6;
  --tertiary-900: #363E47;
  --tertiary-800: #4E5761;
  --tertiary-700: #81919F;
  --tertiary-500: #DEE5EC;
  --tertiary-300: #F6F8FA;
  --white-150: #FFFFFF26;
  --white-200: #FFFFFF59;
  --white-900: #FFFFFF;
  --black-900: #000000;
  --black-300: #000000A6;
  --black-700: #000000CC;
  --transparent: #FFFFFF00;
  --doorbell-500: #0080CC;
  --camera-500: #119E96;
  --alarm-500: #D23313;
  --lighting-500: #7248B5;
  --tags-500: #F52C4F;
  --accessory-500: #A97A3F;
  --access-controller-500: #00994A;
  --works-with-ring-500: #737578;
}

:root {
  --background-deep: #FAFBFC;
  --surface-base: #FFFFFF;
  --surface-inverted: #424242;
  --content-base: #424242;
  --content-backup: #6E6E6E;
  --content-disabled: #BDBDBD;
  --content-muted: #ECECEC;
  --button-content-base: #FFFFFF;
  --content-inverted: #FFFFFF;
  --primary-press: #005188;
  --primary-hover: #0063A5;
  --primary-base: #0074C2;
  --primary-disabled: #A4DEFF;
  --primary-muted: #EFF8FC;
  --primary-text-link-press: #005188;
  --primary-text-link-hover: #0063A5;
  --primary-text-link-base: #0074C2;
  --secondary-press: #9C4308;
  --secondary-hover: #C74E00;
  --secondary-base: #F1670D;
  --secondary-disabled: #FACAAB;
  --secondary-muted: #FDEFE6;
  --positive-press: #22580E;
  --positive-hover: #157217;
  --positive-base: #178019;
  --positive-disabled: #BCDEBD;
  --positive-muted: #F0F8F0;
  --negative-press: #96231D;
  --negative-hover: #B8251D;
  --negative-base: #D4231A;
  --negative-disabled: #F7B9B6;
  --negative-muted: #FCEFEF;
  --caution-press: #A48C22;
  --caution-hover: #CBAC20;
  --caution-base: #FDD835;
  --caution-disabled: #FFF2B9;
  --caution-muted: #FEFBEA;
  --amazon-press: #A66300;
  --amazon-base: #FF9900;
  --amazon-disabled: #FFDBA6;
  --tertiary-border-deep: #81919F;
  --tertiary-border: #DEE5EC;
  --tertiary-background: #F6F8FA;
  --depth-border-muted: #FFFFFF00;
  --depth-border-base: #FFFFFF00;
  --constant-scrim-base: #000000A6;
  --constant-scrim-strong: #000000CC;
  --constant-background-base: #424242;
  --constant-background-deep: #121212;
  --constant-surface-base: #282B2F;
  --constant-content-base: #FFFFFF;
  --constant-content-backup: #BDBDBD;
  --constant-content-disabled: #6E6E6E;
  --constant-primary-press: #A4DEFF;
  --constant-primary-hover: #65BAEB;
  --constant-primary-base: #37B6F3;
  --constant-primary-disabled: #005188;
  --constant-primary-muted: #003d61;
  --constant-primary-text-link-base: #37B6F3;
  --constant-primary-text-link-hover: #65BAEB;
  --constant-primary-text-link-press: #A4DEFF;
  --constant-negative-press: #F7B9B6;
  --constant-negative-hover: #EF7D76;
  --constant-negative-base: #FF554B;
  --constant-negative-disabled: #96231D;
  --constant-negative-muted: #780500;
  --constant-tertiary-background: #363E47;
  --constant-tertiary-border: #4E5761;
  --constant-doorbell-base: #0080CC;
  --constant-camera-base: #119E96;
  --constant-alarm-base: #D23313;
  --constant-lighting-base: #7248B5;
  --constant-tags-base: #F52C4F;
  --constant-accessory-base: #A97A3F;
  --constant-access-controller-base: #00994A;
  --constant-works-with-ring-base: #737578;
  --colorFilter-background-deep: url(#colorFilter-background-deep-light);
  --colorFilter-surface-base: url(#colorFilter-surface-base-light);
  --colorFilter-surface-inverted: url(#colorFilter-surface-inverted-light);
  --colorFilter-content-base: url(#colorFilter-content-base-light);
  --colorFilter-content-backup: url(#colorFilter-content-backup-light);
  --colorFilter-content-disabled: url(#colorFilter-content-disabled-light);
  --colorFilter-content-muted: url(#colorFilter-content-muted-light);
  --colorFilter-button-content-base: url(#colorFilter-button-content-base-light);
  --colorFilter-content-inverted: url(#colorFilter-content-inverted-light);
  --colorFilter-primary-press: url(#colorFilter-primary-press-light);
  --colorFilter-primary-hover: url(#colorFilter-primary-hover-light);
  --colorFilter-primary-base: url(#colorFilter-primary-base-light);
  --colorFilter-primary-disabled: url(#colorFilter-primary-disabled-light);
  --colorFilter-primary-muted: url(#colorFilter-primary-muted-light);
  --colorFilter-primary-text-link-press: url(#colorFilter-primary-text-link-press-light);
  --colorFilter-primary-text-link-hover: url(#colorFilter-primary-text-link-hover-light);
  --colorFilter-primary-text-link-base: url(#colorFilter-primary-text-link-base-light);
  --colorFilter-secondary-press: url(#colorFilter-secondary-press-light);
  --colorFilter-secondary-hover: url(#colorFilter-secondary-hover-light);
  --colorFilter-secondary-base: url(#colorFilter-secondary-base-light);
  --colorFilter-secondary-disabled: url(#colorFilter-secondary-disabled-light);
  --colorFilter-secondary-muted: url(#colorFilter-secondary-muted-light);
  --colorFilter-positive-press: url(#colorFilter-positive-press-light);
  --colorFilter-positive-hover: url(#colorFilter-positive-hover-light);
  --colorFilter-positive-base: url(#colorFilter-positive-base-light);
  --colorFilter-positive-disabled: url(#colorFilter-positive-disabled-light);
  --colorFilter-positive-muted: url(#colorFilter-positive-muted-light);
  --colorFilter-negative-press: url(#colorFilter-negative-press-light);
  --colorFilter-negative-hover: url(#colorFilter-negative-hover-light);
  --colorFilter-negative-base: url(#colorFilter-negative-base-light);
  --colorFilter-negative-disabled: url(#colorFilter-negative-disabled-light);
  --colorFilter-negative-muted: url(#colorFilter-negative-muted-light);
  --colorFilter-caution-press: url(#colorFilter-caution-press-light);
  --colorFilter-caution-hover: url(#colorFilter-caution-hover-light);
  --colorFilter-caution-base: url(#colorFilter-caution-base-light);
  --colorFilter-caution-disabled: url(#colorFilter-caution-disabled-light);
  --colorFilter-caution-muted: url(#colorFilter-caution-muted-light);
  --colorFilter-amazon-press: url(#colorFilter-amazon-press-light);
  --colorFilter-amazon-base: url(#colorFilter-amazon-base-light);
  --colorFilter-amazon-disabled: url(#colorFilter-amazon-disabled-light);
  --colorFilter-tertiary-border-deep: url(#colorFilter-tertiary-border-deep-light);
  --colorFilter-tertiary-border: url(#colorFilter-tertiary-border-light);
  --colorFilter-tertiary-background: url(#colorFilter-tertiary-background-light);
  --colorFilter-depth-border-muted: url(#colorFilter-depth-border-muted-light);
  --colorFilter-depth-border-base: url(#colorFilter-depth-border-base-light);
  --colorFilter-constant-scrim-base: url(#colorFilter-constant-scrim-base-light);
  --colorFilter-constant-scrim-strong: url(#colorFilter-constant-scrim-strong-light);
  --colorFilter-constant-background-base: url(#colorFilter-constant-background-base-light);
  --colorFilter-constant-background-deep: url(#colorFilter-constant-background-deep-light);
  --colorFilter-constant-surface-base: url(#colorFilter-constant-surface-base-light);
  --colorFilter-constant-content-base: url(#colorFilter-constant-content-base-light);
  --colorFilter-constant-content-backup: url(#colorFilter-constant-content-backup-light);
  --colorFilter-constant-content-disabled: url(#colorFilter-constant-content-disabled-light);
  --colorFilter-constant-primary-press: url(#colorFilter-constant-primary-press-light);
  --colorFilter-constant-primary-hover: url(#colorFilter-constant-primary-hover-light);
  --colorFilter-constant-primary-base: url(#colorFilter-constant-primary-base-light);
  --colorFilter-constant-primary-disabled: url(#colorFilter-constant-primary-disabled-light);
  --colorFilter-constant-primary-muted: url(#colorFilter-constant-primary-muted-light);
  --colorFilter-constant-primary-text-link-base: url(#colorFilter-constant-primary-text-link-base-light);
  --colorFilter-constant-primary-text-link-hover: url(#colorFilter-constant-primary-text-link-hover-light);
  --colorFilter-constant-primary-text-link-press: url(#colorFilter-constant-primary-text-link-press-light);
  --colorFilter-constant-negative-press: url(#colorFilter-constant-negative-press-light);
  --colorFilter-constant-negative-hover: url(#colorFilter-constant-negative-hover-light);
  --colorFilter-constant-negative-base: url(#colorFilter-constant-negative-base-light);
  --colorFilter-constant-negative-disabled: url(#colorFilter-constant-negative-disabled-light);
  --colorFilter-constant-negative-muted: url(#colorFilter-constant-negative-muted-light);
  --colorFilter-constant-tertiary-background: url(#colorFilter-constant-tertiary-background-light);
  --colorFilter-constant-tertiary-border: url(#colorFilter-constant-tertiary-border-light);
  --colorFilter-constant-doorbell-base: url(#colorFilter-constant-doorbell-base-light);
  --colorFilter-constant-camera-base: url(#colorFilter-constant-camera-base-light);
  --colorFilter-constant-alarm-base: url(#colorFilter-constant-alarm-base-light);
  --colorFilter-constant-lighting-base: url(#colorFilter-constant-lighting-base-light);
  --colorFilter-constant-tags-base: url(#colorFilter-constant-tags-base-light);
  --colorFilter-constant-accessory-base: url(#colorFilter-constant-accessory-base-light);
  --colorFilter-constant-access-controller-base: url(#colorFilter-constant-access-controller-base-light);
  --colorFilter-constant-works-with-ring-base: url(#colorFilter-constant-works-with-ring-base-light);
}`;
const DARKMODE_COLORS_CSS = `
:root:is([theme-preference=dark], :media(prefers-color-scheme: dark)) {
  --background-deep: #121212;
  --surface-base: #282B2F;
  --surface-inverted: #FFFFFF;
  --content-base: #FFFFFF;
  --content-backup: #BDBDBD;
  --content-disabled: #6E6E6E;
  --content-muted: #424242;
  --button-content-base: #282B2F;
  --content-inverted: #424242;
  --primary-press: #A4DEFF;
  --primary-hover: #65BAEB;
  --primary-base: #37B6F3;
  --primary-disabled: #005188;
  --primary-muted: #003d61;
  --primary-text-link-press: #A4DEFF;
  --primary-text-link-hover: #65BAEB;
  --primary-text-link-base: #37B6F3;
  --secondary-press: #FACAAB;
  --secondary-hover: #F69C61;
  --secondary-base: #FF852B;
  --secondary-disabled: #9C4308;
  --secondary-muted: #602500;
  --positive-press: #BCDEBD;
  --positive-hover: #83C284;
  --positive-base: #5EBF60;
  --positive-disabled: #22580E;
  --positive-muted: #0B4A0C;
  --negative-press: #F7B9B6;
  --negative-hover: #EF7D76;
  --negative-base: #FF554B;
  --negative-disabled: #96231D;
  --negative-muted: #780500;
  --caution-press: #FFF2B9;
  --caution-hover: #FDE57B;
  --caution-base: #FFF653;
  --caution-disabled: #A48C22;
  --caution-muted: #866E04;
  --amazon-press: #FFDBA6;
  --amazon-base: #FF9900;
  --amazon-disabled: #A66300;
  --tertiary-border-deep: #DEE5EC;
  --tertiary-border: #4E5761;
  --tertiary-background: #363E47;
  --depth-border-muted: #FFFFFF26;
  --depth-border-base: #FFFFFF59;
  --colorFilter-background-deep: url(#colorFilter-background-deep-dark);
  --colorFilter-surface-base: url(#colorFilter-surface-base-dark);
  --colorFilter-surface-inverted: url(#colorFilter-surface-inverted-dark);
  --colorFilter-content-base: url(#colorFilter-content-base-dark);
  --colorFilter-content-backup: url(#colorFilter-content-backup-dark);
  --colorFilter-content-disabled: url(#colorFilter-content-disabled-dark);
  --colorFilter-content-muted: url(#colorFilter-content-muted-dark);
  --colorFilter-button-content-base: url(#colorFilter-button-content-base-dark);
  --colorFilter-content-inverted: url(#colorFilter-content-inverted-dark);
  --colorFilter-primary-press: url(#colorFilter-primary-press-dark);
  --colorFilter-primary-hover: url(#colorFilter-primary-hover-dark);
  --colorFilter-primary-base: url(#colorFilter-primary-base-dark);
  --colorFilter-primary-disabled: url(#colorFilter-primary-disabled-dark);
  --colorFilter-primary-muted: url(#colorFilter-primary-muted-dark);
  --colorFilter-primary-text-link-press: url(#colorFilter-primary-text-link-press-dark);
  --colorFilter-primary-text-link-hover: url(#colorFilter-primary-text-link-hover-dark);
  --colorFilter-primary-text-link-base: url(#colorFilter-primary-text-link-base-dark);
  --colorFilter-secondary-press: url(#colorFilter-secondary-press-dark);
  --colorFilter-secondary-hover: url(#colorFilter-secondary-hover-dark);
  --colorFilter-secondary-base: url(#colorFilter-secondary-base-dark);
  --colorFilter-secondary-disabled: url(#colorFilter-secondary-disabled-dark);
  --colorFilter-secondary-muted: url(#colorFilter-secondary-muted-dark);
  --colorFilter-positive-press: url(#colorFilter-positive-press-dark);
  --colorFilter-positive-hover: url(#colorFilter-positive-hover-dark);
  --colorFilter-positive-base: url(#colorFilter-positive-base-dark);
  --colorFilter-positive-disabled: url(#colorFilter-positive-disabled-dark);
  --colorFilter-positive-muted: url(#colorFilter-positive-muted-dark);
  --colorFilter-negative-press: url(#colorFilter-negative-press-dark);
  --colorFilter-negative-hover: url(#colorFilter-negative-hover-dark);
  --colorFilter-negative-base: url(#colorFilter-negative-base-dark);
  --colorFilter-negative-disabled: url(#colorFilter-negative-disabled-dark);
  --colorFilter-negative-muted: url(#colorFilter-negative-muted-dark);
  --colorFilter-caution-press: url(#colorFilter-caution-press-dark);
  --colorFilter-caution-hover: url(#colorFilter-caution-hover-dark);
  --colorFilter-caution-base: url(#colorFilter-caution-base-dark);
  --colorFilter-caution-disabled: url(#colorFilter-caution-disabled-dark);
  --colorFilter-caution-muted: url(#colorFilter-caution-muted-dark);
  --colorFilter-amazon-press: url(#colorFilter-amazon-press-dark);
  --colorFilter-amazon-base: url(#colorFilter-amazon-base-dark);
  --colorFilter-amazon-disabled: url(#colorFilter-amazon-disabled-dark);
  --colorFilter-tertiary-border-deep: url(#colorFilter-tertiary-border-deep-dark);
  --colorFilter-tertiary-border: url(#colorFilter-tertiary-border-dark);
  --colorFilter-tertiary-background: url(#colorFilter-tertiary-background-dark);
  --colorFilter-depth-border-muted: url(#colorFilter-depth-border-muted-dark);
  --colorFilter-depth-border-base: url(#colorFilter-depth-border-base-dark);
  --colorFilter-constant-scrim-base: url(#colorFilter-constant-scrim-base-dark);
  --colorFilter-constant-scrim-strong: url(#colorFilter-constant-scrim-strong-dark);
  --colorFilter-constant-background-base: url(#colorFilter-constant-background-base-dark);
  --colorFilter-constant-background-deep: url(#colorFilter-constant-background-deep-dark);
  --colorFilter-constant-surface-base: url(#colorFilter-constant-surface-base-dark);
  --colorFilter-constant-content-base: url(#colorFilter-constant-content-base-dark);
  --colorFilter-constant-content-backup: url(#colorFilter-constant-content-backup-dark);
  --colorFilter-constant-content-disabled: url(#colorFilter-constant-content-disabled-dark);
  --colorFilter-constant-primary-press: url(#colorFilter-constant-primary-press-dark);
  --colorFilter-constant-primary-hover: url(#colorFilter-constant-primary-hover-dark);
  --colorFilter-constant-primary-base: url(#colorFilter-constant-primary-base-dark);
  --colorFilter-constant-primary-disabled: url(#colorFilter-constant-primary-disabled-dark);
  --colorFilter-constant-primary-muted: url(#colorFilter-constant-primary-muted-dark);
  --colorFilter-constant-primary-text-link-base: url(#colorFilter-constant-primary-text-link-base-dark);
  --colorFilter-constant-primary-text-link-hover: url(#colorFilter-constant-primary-text-link-hover-dark);
  --colorFilter-constant-primary-text-link-press: url(#colorFilter-constant-primary-text-link-press-dark);
  --colorFilter-constant-negative-press: url(#colorFilter-constant-negative-press-dark);
  --colorFilter-constant-negative-hover: url(#colorFilter-constant-negative-hover-dark);
  --colorFilter-constant-negative-base: url(#colorFilter-constant-negative-base-dark);
  --colorFilter-constant-negative-disabled: url(#colorFilter-constant-negative-disabled-dark);
  --colorFilter-constant-negative-muted: url(#colorFilter-constant-negative-muted-dark);
  --colorFilter-constant-tertiary-background: url(#colorFilter-constant-tertiary-background-dark);
  --colorFilter-constant-tertiary-border: url(#colorFilter-constant-tertiary-border-dark);
  --colorFilter-constant-doorbell-base: url(#colorFilter-constant-doorbell-base-dark);
  --colorFilter-constant-camera-base: url(#colorFilter-constant-camera-base-dark);
  --colorFilter-constant-alarm-base: url(#colorFilter-constant-alarm-base-dark);
  --colorFilter-constant-lighting-base: url(#colorFilter-constant-lighting-base-dark);
  --colorFilter-constant-tags-base: url(#colorFilter-constant-tags-base-dark);
  --colorFilter-constant-accessory-base: url(#colorFilter-constant-accessory-base-dark);
  --colorFilter-constant-access-controller-base: url(#colorFilter-constant-access-controller-base-dark);
  --colorFilter-constant-works-with-ring-base: url(#colorFilter-constant-works-with-ring-base-dark);
}`;

export { ACCESSORY_500, ACCESS_CONTROLLER_500, ALARM_500, AMAZON_200, AMAZON_500, AMAZON_700, AMAZON_BASE, AMAZON_DISABLED, AMAZON_PRESS, BACKGROUND_DEEP, BLACK_300, BLACK_700, BLACK_900, BUTTON_CONTENT_BASE, CAMERA_500, CAUTION_100, CAUTION_200, CAUTION_300, CAUTION_400, CAUTION_500, CAUTION_600, CAUTION_700, CAUTION_800, CAUTION_BASE, CAUTION_DISABLED, CAUTION_HOVER, CAUTION_MUTED, CAUTION_PRESS, COLORS, COLORS_CSS, CONSTANT_ACCESSORY_BASE, CONSTANT_ACCESS_CONTROLLER_BASE, CONSTANT_ALARM_BASE, CONSTANT_BACKGROUND_BASE, CONSTANT_BACKGROUND_DEEP, CONSTANT_CAMERA_BASE, CONSTANT_CONTENT_BACKUP, CONSTANT_CONTENT_BASE, CONSTANT_CONTENT_DISABLED, CONSTANT_DOORBELL_BASE, CONSTANT_LIGHTING_BASE, CONSTANT_NEGATIVE_BASE, CONSTANT_NEGATIVE_DISABLED, CONSTANT_NEGATIVE_HOVER, CONSTANT_NEGATIVE_MUTED, CONSTANT_NEGATIVE_PRESS, CONSTANT_PRIMARY_BASE, CONSTANT_PRIMARY_DISABLED, CONSTANT_PRIMARY_HOVER, CONSTANT_PRIMARY_MUTED, CONSTANT_PRIMARY_PRESS, CONSTANT_PRIMARY_TEXT_LINK_BASE, CONSTANT_PRIMARY_TEXT_LINK_HOVER, CONSTANT_PRIMARY_TEXT_LINK_PRESS, CONSTANT_SCRIM_BASE, CONSTANT_SCRIM_STRONG, CONSTANT_SURFACE_BASE, CONSTANT_TAGS_BASE, CONSTANT_TERTIARY_BACKGROUND, CONSTANT_TERTIARY_BORDER, CONSTANT_WORKS_WITH_RING_BASE, CONTENT_BACKUP, CONTENT_BASE, CONTENT_DISABLED, CONTENT_INVERTED, CONTENT_MUTED, DARKMODE_COLORS_CSS, DEPTH_BORDER_BASE, DEPTH_BORDER_MUTED, DOORBELL_500, FACEBOOK_BLUE, FORD_GREY, GREY_53, GREY_78, LIGHTING_500, NATIVE_GREY, NEGATIVE_100, NEGATIVE_200, NEGATIVE_300, NEGATIVE_400, NEGATIVE_500, NEGATIVE_600, NEGATIVE_700, NEGATIVE_800, NEGATIVE_BASE, NEGATIVE_DISABLED, NEGATIVE_HOVER, NEGATIVE_MUTED, NEGATIVE_PRESS, NEUTRAL_100, NEUTRAL_200, NEUTRAL_300, NEUTRAL_50, NEUTRAL_500, NEUTRAL_800, NEUTRAL_900, NEXT_DOOR_GREEN, POSITIVE_100, POSITIVE_200, POSITIVE_300, POSITIVE_400, POSITIVE_500, POSITIVE_600, POSITIVE_700, POSITIVE_800, POSITIVE_BASE, POSITIVE_DISABLED, POSITIVE_HOVER, POSITIVE_MUTED, POSITIVE_PRESS, PRIMARY_100, PRIMARY_200, PRIMARY_300, PRIMARY_400, PRIMARY_500, PRIMARY_600, PRIMARY_700, PRIMARY_800, PRIMARY_BASE, PRIMARY_DISABLED, PRIMARY_HOVER, PRIMARY_MUTED, PRIMARY_PRESS, PRIMARY_TEXT_LINK_BASE, PRIMARY_TEXT_LINK_HOVER, PRIMARY_TEXT_LINK_PRESS, SECONDARY_100, SECONDARY_200, SECONDARY_300, SECONDARY_400, SECONDARY_500, SECONDARY_600, SECONDARY_700, SECONDARY_800, SECONDARY_BASE, SECONDARY_DISABLED, SECONDARY_HOVER, SECONDARY_MUTED, SECONDARY_PRESS, SEMANTIC_COLORS, SEMANTIC_COLOR_CODES, SNOW, SURFACE_BASE, SURFACE_INVERTED, TAGS_500, TERTIARY_300, TERTIARY_500, TERTIARY_700, TERTIARY_800, TERTIARY_900, TERTIARY_BACKGROUND, TERTIARY_BORDER, TERTIARY_BORDER_DEEP, TRANSPARENT, TWITTER_PRIMARY, WHITE_150, WHITE_200, WHITE_900, WORKS_WITH_RING_500 };
